module.exports = __webpack_public_path__ + "img/product_32.46287de.webp";